export default "__VITE_ASSET__C1TIo4xk__$_?no-inline__"